import Swiper, { Navigation } from 'swiper';

function initializeSwiper(container) {
  const sliderWrapper = container.closest('.cards-slider');
  const prevButton = sliderWrapper.querySelector('.cards-slider__button--prev');
  const nextButton = sliderWrapper.querySelector('.cards-slider__button--next');

  // eslint-disable-next-line no-new
  new Swiper(container, {
    slidesPerView: 1,
    loop: false,
    modules: [Navigation],
    allowTouchMove: true,
    spaceBetween: 24,
    navigation: {
      prevEl: prevButton,
      nextEl: nextButton,
    },
    breakpoints: {
      768: {
        slidesPerView: 2,
        allowTouchMove: true,
      },
      1024: {
        slidesPerView: 3,
        allowTouchMove: false,
      },
    },
  });
}

window.document.addEventListener('DOMContentLoaded', () => {
  const swiperContainerClass = '.cards-slider__swiper';
  const swiperContainers = document.querySelectorAll(swiperContainerClass);

  if (window.acf) {
    window.acf.addAction('render_block_preview/type=azds/cards-slider', ($block) => {
      initializeSwiper($block.find(swiperContainerClass)[0]);
    });
  } else {
    swiperContainers.forEach(initializeSwiper);
  }
});
